import ReactDOM from 'react-dom/client';

import MainComponent from '@/MainComponent';
import MarkBooted from '@/components/MarkBooted';
import ThemeProvider from '@/app/contexts/ThemeProvider';
import { initializeTheme } from '@/app/contexts/theme';

import './tailwind.css';
import './fonts.css';

const root = document.getElementById('root')!;

initializeTheme();

ReactDOM.createRoot(root).render(
  <ThemeProvider>
    <MainComponent />
    <MarkBooted />
  </ThemeProvider>
);
